let code = 'gugestao';
let codeAPI = 'gu';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};